import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const PhoneVerification = ({ isVerified, needShowText }) => {
  const { t } = useTranslation('common')

  return (
    <div className={
      `sidebar-user-verifikacija-item user-card__verification-phone ${isVerified ? 'is-verifikovana' : ''}`
    }>
      <i className='ico-user-verifikacija-mobilnog ico' />
      {needShowText ? <p>{t('verifikovan telefon')}</p> : null}
    </div>
  )
}

PhoneVerification.propTypes = {
  isVerified: PropTypes.bool.isRequired,
  needShowText: PropTypes.bool.isRequired
}

PhoneVerification.defaultProps = {
  isVerified: false,
  needShowText: true
}
